import {BASE_ADMIN_API, fetchAPI} from '@/services/api';

// Role 类型定义
export interface Role {
    roleId: number;
    roleName: string;
    roleType: number;
    remark: string;
    status: number;
    dataType: number;
    isHidden: number;
    label: number;
    rules: Record<string, any>;
    menuIds: number[];
}

export interface RequestRole {
    userIds?: number[];
    deptIds?: number[];
    roleIds?: number[];
    menuIds?: number[];
}

const defaultUrl = BASE_ADMIN_API + '/role';

// query role by Id
export async function getRoleById(roleId: number) {
    return fetchAPI<Role>(`${defaultUrl}/getRoleById/${roleId}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}

// query role list
export async function queryRoleList() {
    return fetchAPI<Role[]>(`${defaultUrl}/queryRoleList`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}

// create role
export async function createRole(role: Omit<Role, 'roleId'>) {
    return fetchAPI<Role>(`${defaultUrl}/createRole`, {
        method: 'POST',
        body: JSON.stringify(role),
        headers: {'Content-Type': 'application/json'},
    });
}

// update role
export async function updateRole(roleId: number, role: Role) {
    return fetchAPI<Role>(`${defaultUrl}/updateRole/${roleId}`, {
        method: 'POST',
        body: JSON.stringify(role),
        headers: {'Content-Type': 'application/json'},
    });
}

// remove role
export async function deleteRole(roleId: number) {
    return fetchAPI<void>(`${defaultUrl}/deleteRole/${roleId}`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
    });
}

// //------------------------------------------------------------
// //---------------   Relate API        ------------------------
// //------------------------------------------------------------
//
// export async function relatedRoleUser(requestRole: RequestRole) {
//     return fetchAPI<void>(`${defaultUrl}/relatedRoleUser`, {
//         method: 'POST',
//         body: JSON.stringify(requestRole),
//         headers: {'Content-Type': 'application/json'},
//     });
// }
//
// export async function relatedRoleDeptUser(requestRole: RequestRole) {
//     return fetchAPI<void>(`${defaultUrl}/relatedRoleDeptUser`, {
//         method: 'POST',
//         body: JSON.stringify(requestRole),
//         headers: {'Content-Type': 'application/json'},
//     });
// }
//
// export async function updateRoleMenu(requestRole: RequestRole) {
//     return fetchAPI<void>(`${defaultUrl}/updateRoleMenu`, {
//         method: 'POST',
//         body: JSON.stringify(requestRole),
//         headers: {'Content-Type': 'application/json'},
//     });
// }
//
// export async function unbindingUser(userId: number, roleId: number) {
//     return fetchAPI<void>(`${defaultUrl}/unbindingUser?${userId}&&${roleId}`, {
//         method: 'POST',
//         headers: {'Content-Type': 'application/json'},
//     });
// }

//------------------------------------------------------------
//---------------   New Role APIs (Relations)  ---------------
//------------------------------------------------------------

// Minimal VO interfaces (adjust fields as your backend returns)
export interface AdminRoleVO { [key: string]: any }
export interface AdminMenuVO { [key: string]: any }

// assign users to role
export async function assignUsersToRole(roleId: number, userIds: number[]) {
    const body = { roleIds: [roleId], userIds };
    return fetchAPI<void>(`${defaultUrl}/assignUsersToRole`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {'Content-Type': 'application/json'},
    });
}

// assign menus to role
export async function assignMenusToRole(roleId: number, menuIds: number[]) {
    const body = { roleIds: [roleId], menuIds };
    return fetchAPI<void>(`${defaultUrl}/assignMenusToRole`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {'Content-Type': 'application/json'},
    });
}

// assign auths to role
export async function assignAuthsToRole(roleId: number, authIds: number[]) {
    const body = { roleIds: [roleId], authIds };
    return fetchAPI<void>(`${defaultUrl}/assignAuthsToRole`, {
        method: 'POST',
        body: JSON.stringify(body),
        headers: {'Content-Type': 'application/json'},
    });
}

// get role with relations by id
export async function getRoleWithRelations(roleId: number) {
    return fetchAPI<AdminRoleVO>(`${defaultUrl}/getRoleWithRelations/${roleId}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}

// get roles with relations by ids
export async function getRolesWithRelations(roleIds: number[]) {
    return fetchAPI<AdminRoleVO[]>(`${defaultUrl}/getRolesWithRelations`, {
        method: 'POST',
        body: JSON.stringify(roleIds),
        headers: {'Content-Type': 'application/json'},
    });
}

// get role permission tree
export async function getRolePermissionTree(roleId: number) {
    return fetchAPI<AdminMenuVO[]>(`${defaultUrl}/getRolePermissionTree/${roleId}`, {
        method: 'GET',
        headers: {'Content-Type': 'application/json'},
    });
}